import PropTypes from 'prop-types';
import React from 'react';
import { DropTarget } from 'react-dnd';
import TitledPanel from '../../core/TitledPanel';

const Types = {
  ANNOTATION: 'annotation',
  XLLABEL: 'xllabel'
};

const target = {
  canDrop(props, monitor) {
    if (props.isReadOnly) return false;
    const item = monitor.getItem();
    if (item.type === "Concept") {
      return item.conceptId !== props.id;
    }
    else return true;
  },
  drop(props, monitor) {
    const item = monitor.getItem();
    if (item.type === "Annotation") {
      props.onMoveAnnotation(item.annotationLabel, item.annotationLang);
    }
    else {
      props.onMoveLabel(item.labelId, item.labelLang);
    }
  }
};

function collectTarget(connect, monitor) {
  return {
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

class DropPreferredPanel extends React.Component {


  render() {

    const { isOver, connectDropTarget, canDrop, isReadOnly } = this.props;

    return connectDropTarget(
      <div style={{height: '100%'}}>
        <TitledPanel {...this.props} highlight={isOver && canDrop && !isReadOnly} />
      </div>
    );
  }
}

DropPreferredPanel.defaultProps = {
  isReadOnly: false
};

DropPreferredPanel.propTypes = {
  isReadOnly: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onMoveAnnotation: PropTypes.func.isRequired,
  onMoveLabel: PropTypes.func.isRequired
};

export default DropTarget([Types.ANNOTATION, Types.XLLABEL], target, collectTarget)(DropPreferredPanel);